import Vue from 'vue'
import Vuex from 'vuex'
import user from './moudles/user';
import global_info from './moudles/global_info';

Vue.use(Vuex);

let store = new Vuex.Store({
  modules: {
    user,
    global_info
  }
});


export default store;



// WEBPACK FOOTER //
// ./src/store/index.js